import { render, staticRenderFns } from "./Brasil.vue?vue&type=template&id=ef848ea0&"
import script from "./Brasil.vue?vue&type=script&lang=js&"
export * from "./Brasil.vue?vue&type=script&lang=js&"
import style0 from "./Brasil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports